import { FC } from 'react';
import { ArrowDown, ArrowUp } from 'lucide-react';

interface Props {
  // Which way the student's current position lies from here: 'up' when it is scrolled off the top,
  // 'down' when it is below the fold.
  direction: 'up' | 'down';
  onClick: () => void;
}

/**
 * The "Back to position" control: a text link with an arrow pointing toward the student's current
 * position on the unit path, which scrolls it back into view on click. Purely presentational — the
 * decision of whether to show it (and where) belongs to UnitPathRail.
 */
export const BackToPositionButton: FC<Props> = ({ direction, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="tw-inline-flex tw-items-center tw-gap-2 tw-bg-transparent tw-border-none tw-cursor-pointer tw-text-blue-500 hover:tw-text-[#0C1B54] tw-font-atkinson tw-text-base tw-font-bold focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#0C1B54] focus-visible:tw-ring-offset-2 focus-visible:tw-rounded-md"
  >
    Back to position
    {direction === 'up' ? <ArrowUp className="tw-h-4 tw-w-4" /> : <ArrowDown className="tw-h-4 tw-w-4" />}
  </button>
);

export default BackToPositionButton;
